import { Table, TableHead, TableRow, TableContainer } from '@mui/material';
import { FetchProofreadEventsApi } from 'api/mypage/proofread_plans/proofread_event';
import ApprovedResultEventFormDialog from 'components/mypage/proofread/proofread_event/approved_result_event_form_dialog';
import { CheckboxFooter } from 'components/shared/checkbox_footer';
import ImageView from 'components/shared/image_view';
import { useMultipleModal } from 'components/shared/modal';
import Pagination from 'components/shared/pagination';
import { InstrumentCategoryFilterTableHeader } from 'components/shared/proofread/instrument_category_filter_table_header';
import { InstrumentInfoFilterTableHeader } from 'components/shared/proofread/instrument_info_filter_table_header';
import { ExTableCell, ExTableBody, ExTableRow, AllCheckboxTableCell, CheckboxTableCell } from 'components/shared/table';
import { TableExAttributesInfo } from 'components/shared/table_ex_attributes_info';
import ThemedButton from 'components/shared/themed_button';
import { ExColumn } from 'entities/ex_column';
import { ProofreadEvent, ProofreadEventSearchForm } from 'entities/proofread_event';
import { Form } from 'rac';
import React from 'react';
import { getTableHeight, PROOFREAD_CHECKED_TABLE_PADDING, PROOFREAD_TABLE_PADDING } from 'utils/component_heights';
import { useCheckboxes } from 'utils/hooks';
import { useProofreadEventFilter } from 'utils/hooks/use_proofread_event_filter';
import { ProofreadEventViewModel } from 'view_models/proofread_event';

type ApprovedResultEventTableProps = {
  indexApi: FetchProofreadEventsApi;
  searchForm: Form<ProofreadEventSearchForm>;
  tableShowColumns: ExColumn[];
  onUpdate: () => void;
  onClickExAttr: (event: ProofreadEvent) => void;
  onClickBulkExAttr: (eventIds: number[]) => void;
};
export const ApprovedResultEventTable: React.FC<ApprovedResultEventTableProps> = (props) => {
  const proofreadEventFilterSet = useProofreadEventFilter(
    props.indexApi.response.filter,
    props.searchForm,
    props.indexApi
  );
  const checkModalSet = useMultipleModal<ProofreadEvent>();
  const checkboxSet = useCheckboxes(props.indexApi.response.proofreadEvents);

  return (
    <>
      <ApprovedResultEventFormDialog modalSet={checkModalSet} onComplete={props.onUpdate} />
      <TableContainer
        style={{
          maxHeight:
            checkboxSet.checkedIds.length > 0
              ? getTableHeight(PROOFREAD_CHECKED_TABLE_PADDING)
              : getTableHeight(PROOFREAD_TABLE_PADDING),
        }}
      >
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <AllCheckboxTableCell checkboxSet={checkboxSet} />
              <ExTableCell />
              <ExTableCell>
                <InstrumentInfoFilterTableHeader proofreadEventFilterSet={proofreadEventFilterSet} />
                {props.tableShowColumns.map((col) => (
                  <div style={{ fontSize: 12, lineHeight: '12px' }} key={`tablecol-${col.id}`}>
                    {col.name}
                  </div>
                ))}
              </ExTableCell>
              <ExTableCell align="center">
                <InstrumentCategoryFilterTableHeader proofreadEventFilterSet={proofreadEventFilterSet} />
              </ExTableCell>
              <ExTableCell />
              <ExTableCell align="center">委託先</ExTableCell>
              <ExTableCell align="center">担当者</ExTableCell>
              <ExTableCell align="center">部屋</ExTableCell>
              <ExTableCell />
              <ExTableCell />
            </TableRow>
          </TableHead>
          <ExTableBody loading={props.indexApi.loading}>
            {props.indexApi.response.proofreadEvents.map((event: ProofreadEvent) => {
              const vm = new ProofreadEventViewModel(event);
              return (
                <ExTableRow key={event.id}>
                  <CheckboxTableCell checkboxId={event.id!} checkboxesSet={checkboxSet} />
                  <ExTableCell width={100}>
                    <ImageView maxHeight={100} maxWidth={100} src={vm.getInstrumentImage()} />
                  </ExTableCell>
                  <ExTableCell>
                    {vm.getInstrumentInfo()}
                    <TableExAttributesInfo tableExAttrs={event.tableExAttrs || []} id={event.id} />
                  </ExTableCell>
                  <ExTableCell align="center">{vm.getInstrumentCategoryName()}</ExTableCell>
                  <ExTableCell align="center">{vm.getResultLabel()}</ExTableCell>
                  <ExTableCell align="center">{vm.getSupplier()}</ExTableCell>
                  <ExTableCell align="center">{vm.getUser()}</ExTableCell>
                  <ExTableCell align="center">{vm.getRoom()}</ExTableCell>
                  <ExTableCell width={122}>
                    <ThemedButton color="success" onClick={() => props.onClickExAttr(event)}>
                      管理情報
                    </ThemedButton>
                  </ExTableCell>
                  <ExTableCell>
                    <ThemedButton color="secondary" onClick={() => checkModalSet.openModal(event)}>
                      確認
                    </ThemedButton>
                  </ExTableCell>
                </ExTableRow>
              );
            })}
          </ExTableBody>
        </Table>
      </TableContainer>
      <CheckboxFooter
        checkboxSet={checkboxSet}
        content={
          <>
            <ThemedButton
              color="success"
              onClick={() => props.onClickBulkExAttr(checkboxSet.checkedIds)}
              style={{ marginRight: 12 }}
            >
              管理情報を一括更新
            </ThemedButton>
          </>
        }
      />
      <Pagination response={props.indexApi.response} pageSet={props.indexApi.pageSet} />
    </>
  );
};

export default ApprovedResultEventTable;
